










































import { Component, Mixins } from "vue-property-decorator";
import CProdInjectorMixin from "@/mixins/cProdInjectorMixin";
import CProdProvInjectorMixin from "@/mixins/cProdProvInjectorMixin";

@Component({
  components: {
    "cprod-image": () =>
      import("@/components/app/global/contractProducts/cProdImage.vue"),
    "cprod-tags": () =>
      import("@/components/app/global/contractProducts/cProdTags.vue"),
    "cprod-prov-actions": () =>
      import("@/components/app/global/contractProducts/cProdProvActions.vue")
  }
})
export default class CProdClientBillboard extends Mixins(
  CProdInjectorMixin,
  CProdProvInjectorMixin
) {
  public get showImage() {
    if (!this.cProdData.contractProduct) return false;
    return !!this.cProdData.images.length;
  }

  public get client() {
    return this.cProdData.contract?.client;
  }
}
